import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Location } from "@angular/common";
import { AuthStore } from "../pages/auth/store/auth.store";
import {
  hasOrganizationCapability,
  OrganizationCapabilities,
} from "../model/country-support.model";

export const organizationCapabilityGuard = (
  capability: keyof OrganizationCapabilities,
): CanActivateFn => {
  return () => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    const location = inject(Location);

    if (
      hasOrganizationCapability(
        { capabilities: authStore.capabilities() },
        capability,
      )
    ) {
      return true;
    }

    return router.createUrlTree(["/home/403-forbidden"], {
      queryParams: {
        returnUrl: encodeURIComponent(location.path()),
        capability,
      },
    });
  };
};
